package com.dotdrives.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlin.time.Instant

@Serializable
data class RecurringSchedule(
    val id: String,
    @SerialName("giver_id") val giverId: String,
    @SerialName("giver_name") val giverName: String,
    @SerialName("target_name") val targetName: String? = null,
    val amount: Double,
    val currency: String = "usd",
    val interval: String,
    val status: String,
    @SerialName("payment_status") val paymentStatus: String? = null,
    @SerialName("next_charge_at") val nextChargeAt: Instant? = null,
    @SerialName("cancel_at_period_end") val cancelAtPeriodEnd: Boolean = false,
    @SerialName("verified_at") val verifiedAt: Instant? = null,
    val verification: String,
    @SerialName("can_manage") val canManage: Boolean = false,
)

/** Server authority is required; these additional checks only shape the controls. */
fun RecurringSchedule.managementActions(): Set<String> =
    if (!canManage || cancelAtPeriodEnd || currency != "usd" || interval !in setOf("monthly", "quarterly") ||
        status !in setOf("active", "trialing", "past_due", "paused")) emptySet()
    else setOf("amount", if (status == "paused") "resume" else "pause", "cancel")

@Serializable
data class RecurringSchedulePage(val items: List<RecurringSchedule> = emptyList(), val total: Int = 0)
